/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaTipologyList } from "../sagas/sagasTipology";

export function* watcherTipology(): unknown {
  yield takeLatest(TActionType.tipologyListRequest, sagaTipologyList);
}
